import React, { useState } from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import InfoIcon from '@material-ui/icons/Info';
import CheckIcon from '@material-ui/icons/Check';
import Tooltip from "@material-ui/core/Tooltip";

const CssTextField = withStyles({
  root: {
    width: "100%",
    margin: "12px 0",

    "& label.MuiInputLabel-filled": {
      color: "#8987A2",
      transform: "translate(16px, 15px) scale(1)",

      "&.Mui-error": {
        color: "#F87777"
      }
    },

    "& label.Mui-focused": {
      color: "#8987A2"
    },

    "& .MuiFilledInput-root": {
      background: "#F6F6FB",
      borderRadius: "4px",
      color: '#3C3C56',

      "& fieldset": {
        border: "2px solid #8094FF",
      },

      "&:hover fieldset": {
        outline: "2px solid #8094FF",
      },

      "&.Mui-focused": {
        background: "#FFFFFF",
        outline: "2px solid #8094FF",
      },

      "&.Mui-error": {
        outline: "2px solid #F87777"
      }
    }
  },
})(TextField);

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap"
  },
  // margin: {
  //   margin: theme.spacing(1)
  // }
}));

const CustomTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: 'rgba(60, 60, 86, 0.8)',
    color: '#FFFFFF',
    boxShadow: 'none',
    padding: 12,
    borderRadius: 8,
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: '14px',
  },
}))(Tooltip);

export default function CustomizedInputs(props) {
  const classes = useStyles();

  return (
    <div className={classes.root} noValidate>
      <CssTextField
        size="small"
        label={props.label}
        className={classes.margin}
        variant="filled"
        type={props.type}
        error={props.error}
        defaultValue={props.defaultValue}
        value={props.value}
        // helperTooltip={props.helperText}
        onChange={props.onChange}
        hint={props.hint}

        InputProps={{
          disabled: props.disabled,
          disableUnderline: true,
          type: "text",
          multiline: props.multiline,
          endAdornment: (
            props.hint
              ?
              <CustomTooltip title={props.helperText}>
                <InputAdornment position="end" style={{ cursor: "pointer", paddingRight: 4 }}>
                  {
                    props.error
                      ?
                      <InfoIcon htmlColor='#F87777' />
                      :
                      props.valid
                        ?
                        <CheckIcon htmlColor='#81D39D' />
                        :
                        <InfoOutlinedIcon htmlColor='#BCBBD0' />
                  }
                </InputAdornment>
              </CustomTooltip>
              :
              ''
          )
        }}
      />
    </div>
  );
}
